import { Box, Text, Link, Alert, AlertIcon } from '@chakra-ui/react';

const AdminHelp: React.FC = () => {
  return (
    <Box mt={6}>
      <Alert status="info" borderRadius="md">
        <AlertIcon />
        <Text>
          Pro kompletní dokumentaci navštivte{' '}
          <Link href="/docs" color="blue.600" fontWeight="semibold" textDecoration="underline">
            dokumentaci administrace
          </Link>
        </Text>
      </Alert>
    </Box>
  );
};

export default AdminHelp;
